import { render, staticRenderFns } from "./UsersTab.vue?vue&type=template&id=37b7f6ec&scoped=true"
import script from "./UsersTab.vue?vue&type=script&lang=js"
export * from "./UsersTab.vue?vue&type=script&lang=js"
import style0 from "./UsersTab.vue?vue&type=style&index=0&id=37b7f6ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b7f6ec",
  null
  
)

export default component.exports